import React from "react";

import HouseholdCard from "./HouseholdCard";

const DOT_COLOR_CLASSES = {
  orange: "bg-orange-500",
  red: "bg-red-500",
  green: "bg-emerald-500",
  blue: "bg-blue-500",
};

const BucketSection = ({
  bucket,
  projectId,
  navigate,
  actions,
  onActionComplete,
  variant = "card",
}) => {
  if (!bucket) return null;
  const households = bucket.households || [];
  if (households.length === 0) return null;

  const isCard = variant === "card";
  const dot = DOT_COLOR_CLASSES[bucket.dot_color] || "bg-gray-400";

  return (
    <div
      className={
        isCard
          ? "bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden flex flex-col h-[440px]"
          : "mb-4 last:mb-0"
      }
    >
      <div
        className={
          isCard
            ? "flex items-center justify-between px-4 py-3 border-b border-gray-200 bg-white"
            : "flex items-center justify-between mb-3 px-1"
        }
      >
        <div className="flex items-center gap-2.5">
          <span
            className={`inline-block w-2.5 h-2.5 rounded-full ring-2 ring-white shadow-sm ${dot}`}
          />
          <h3 className="text-[15px] font-bold text-gray-900 tracking-tight">
            {bucket.label}
          </h3>
        </div>
        <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-gray-100 border border-gray-200 text-gray-700">
          {households.length} Household{households.length === 1 ? "" : "s"}
        </span>
      </div>

      <div
        className={
          isCard
            ? "p-3 flex-1 min-h-0 overflow-y-auto space-y-2.5 bg-gray-100/70"
            : "max-h-[320px] overflow-y-auto pr-1 space-y-2.5 rounded-lg"
        }
      >
        {households.map((card) => (
          <HouseholdCard
            key={card.id}
            card={card}
            projectId={projectId}
            navigate={navigate}
            actions={actions}
            onActionComplete={onActionComplete}
          />
        ))}
      </div>
    </div>
  );
};

export default BucketSection;
